export const setPassword = {
  old_passwd: "sys_old_passwd",
  new_passwd: "sys_new_passwd",
  confirm_passwd: "sys_confirm_passwd",
};

export default setPassword;
